<template>
    <div class="explore " id="selfexplore">
        <masks v-show="addtanchuang||false"></masks>
        <div class="schoolWork" style="margin-bottom: 20px">
            <div>
                <img src="/imgs/selfAssessment/icon_xueshengziwopinggu.png" alt="">
                <div class="item_scoll">
                    <div class="tishi">
                    <div class="box" style="color: red;font-weight: bolder">
                        <marquee behavior="marquee" direction="" style="display:block;width: 934px;position: absolute;left:50px;letter-spacing: 2px; white-space:nowrap;">
                            <div style="position: relative;right:780px;display: inline">请使用windows7及以上系统、谷歌最新浏览器、有线鼠标进行测试</div>
                            <div style="display: inline;position: relative;right:220px;margin-right:560px" v-for="item in 5">请使用windows7及以上系统、谷歌最新浏览器、有线鼠标进行测试</div>
                        </marquee>
                    <!-- <span @click="close($event)"></span> -->
                    </div>
                </div>
                </div>
                
                <!-- 生涯测评 -->
                <div class="flex_div">                       
                        <div v-if="getList.career_test">
                            <div class="schoolWorkBox">
                                <ul class="electiveBox">
                                    <li v-for="(item,index) in cdata1">
                                        <div class="left">
                                            <img :src="item.src" alt="">
                                        </div>
                                        <div class="right">
                                            <div class="title">
                                                <span>{{item.title}}</span>
                                                <!-- <img :src="item.vip" alt=""> -->
                                            </div>
                                            <p v-html="item.content">
                                            </p>
                                            <p class="quest_num"><span><img src="/imgs/selfAssessment/zuoti.png" />{{career_num.question_num}}</span><img src="/imgs/selfAssessment/shijian.png" />{{career_num.question_time}}</p>
                                            <div class="button" @click="jump(item.link,index)" :style='{filter:
                                    index==0&&(!careerTest)&&"grayscale(100%)"||
                                    index==1&&(!careerBool)&&"grayscale(100%)"||"none"}'>
                                                {{item.button}}
                                            </div>
                                            <!-- <button class="button mask" @click="jumps(item.links)" style="right:120px;color:#157DFA;border:1px solid #157DFA;background:none">{{item.mask}}</button> -->
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <!-- 生涯适应力测评 -->
                        <div class="schoolWorkBox" v-if="getList.career_adaptability_test">
                            <ul class="electiveBox">
                                <li v-for="(item,index) in cdata2">
                                    <div class="left">
                                        <img :src="item.src" alt="">
                                    </div>
                                    <div class="right">
                                        <div class="title">
                                            {{item.title}}
                                        </div>
                                        <p v-html="item.content">
                                        </p>
                                        <div class="button" @click="jump(item.link)" >
                                            {{item.button}}
                                        </div>
                                        <div class="button mask" @click="isShowMark = true" style="right:120px;color:#157DFA;border:1px solid #157DFA;background:none">
                                            {{item.mask}}
                                        </div>
                                    </div>
                                </li>
                            </ul>
                            <div class="mark" v-show="isShowMark">
                                <div class="tips">
                                    <ul>
                                        <li v-for="(item, index) in adaptabilityList" :key="index">
                                            <span>{{item.createdAt}}测评</span>
                                            <div class="btn" @click="goReport(item.id)">
                                                查看
                                            </div>
                                        </li>
                                    </ul>
                                    <div class="close" @click="isShowMark= false"></div>
                                </div>
                            </div>
                        </div>
                        <!-- 学习力测评 -->
                        <div class="schoolWorkBox" v-if="getList.learning_test">
                            <ul class="electiveBox">
                                <li v-for="(item,index) in cdata3">
                                    <div class="left">
                                        <img :src="item.src" alt="">
                                    </div>
                                    <div class="right">
                                        <div class="title">
                                            <span>{{item.title}}</span>
                                            <!-- <img :src="item.vip" alt=""> -->
                                        </div>
                                        <p v-html="item.content">
                                        </p>
                                        <p class="quest_num"><span><img src="/imgs/selfAssessment/zuoti.png" />{{learning_capacity.question_num}}</span><img src="/imgs/selfAssessment/shijian.png" />{{learning_capacity.question_time}}</p>
                                        <div class="button" @click="goCreateLearningTest()">
                                            {{item.button}}
                                        </div>
                                        <!-- <button class="button mask" @click="jumps(item.links)" style="right:120px;color:#157DFA;border:1px solid #157DFA;background:none">{{item.mask}}</button> -->
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <!-- 学习状态诊断 -->
                        <div class="schoolWorkBox" v-if="getList.learning_state_test">
                            <ul class="electiveBox">
                                <li v-for="(item,index) in cdata4">
                                    <div class="left">
                                        <img :src="item.src" alt="">
                                    </div>
                                    <div class="right">
                                        <div class="title">
                                            {{item.title}}
                                        </div>
                                        <p v-html="item.content">
                                        </p>
                                        <div class="button" @click="jump(item.link)">
                                            {{item.button}}
                                        </div>
                                        <div class="button mask" @click="jumps(item.links)" style="right:120px;color:#157DFA;border:1px solid #157DFA;background:none">
                                            {{item.mask}}
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="schoolWorkBox">
                            <ul class="electiveBox">
                              <li class="come_box">
                                  <img src="/imgs/selfAssessment/come_icon.svg" class="come_icon"/><br/>
                                  <p class="come_text">敬请期待</p>
                                  
                              </li>
                            </ul>
                        </div>
                </div>
            </div>
        </div>
        <card-shengya v-if="isShowjihuoka" v-on:goClose="isShowjihuoka = false" :codeUrl="codeUrl" :isZhifou="isZhifou" :cardType="cardType" :pathUrl="pathUrl" :cardTitle="cardTitle"></card-shengya>
     </div>
</template>
<script>
    import  masks from '../../components/mask.vue'
    // 引入激活生涯卡组件
    import CardShengya from '../../components/CardShengya.vue';
    export default {
        name: "",
        components:{masks,CardShengya},
        data(){
            return{
                careerVersion:'',
                isZhufou: false,
                isShowjihuoka: false,
                cardTitle: '生涯卡',
                cardType: 1,
                codeUrl: '',
                pathUrl: '',
                isShowLearnCapacity: false,
                cdata1:[
                    {
                        src:"/imgs/selfAssessment/icon_shengyaceping.png",
                        vip:"/imgs/selfAssessment/icon_fufei.png",
                        title:"生涯测评",
                        content:'科学测评系统再优化，采用心理物理学测量方法，针对人格、兴趣、智能和价值观，对专业、职业进行综合匹配。',
                        button:"开始测评",
                        link:"/careerevalution",
                        // links:'/shengyaceping'
                        // links:"/studyPlan/studentMessage/grade/list",
                        // mask:'查看测评'
                    }
                ],
                cdata2:[
                    {
                        src:"/imgs/selfAssessment/icon_shiyingli.png",
                        title:"生涯适应力测评",
                        content:"对我们的优势和劣势进行测评。",
                        button:"开始测评",
                        link:"/selfAssessment/adaptability",
                        mask:'查看测评',
                    },
                    // {
                    //     src:"/imgs/selfAssessment/icon_chakancepingjilu.png",
                    //     title:"查看测评记录",
                    //     content:"查看生涯适应力的变化。",
                    //     button:"查看",
                    //     link:""
                    // }
                ],
                cdata3:[
                    {
                        src:"/imgs/selfAssessment/icon_xuexiliceping.png",
                        vip:"/imgs/selfAssessment/icon_fufei.png",
                        title:"学习力测评",
                        content:"帮助学生从学习潜力、学习动力、学习效力等内因出发，全方位提升。",
                        button:"开始测评",
                        // link:"/learningAbility",
                        cardType: 9,
                        // links:"/studyPlan/studentMessage/grade/list",
                        // mask:'查看测评'
                    }
                ],
                cdata4:[
                    {
                        src:"/imgs/selfAssessment/icon_xuexizhuangtaiceping.png",
                        title:"学习状态诊断测评",
                        content:"学习状态诊断测评,学习状态诊断测评学习状态诊断测评。",
                        button:"前往测评",
                        link:"/selfAssessment/diagnosis",
                        mask:"查看测评",
                        links:'/selfAssessment/diagnosis'
                    },
                    // {
                    //     src:"/imgs/selfAssessment/icon_chakancepingjilu.png",
                    //     title:"查看测评记录",
                    //     content:"",
                    //     button:"查看报告",
                    //     link:"/selfAssessment/diagnosis"
                    // }
                ],
                lists:[],
                adaptabilityList: [],
                isShowMark: false,
                addtanchuang:false,
 

                careerLinks:'',//生涯测评报告链接
                careerBool:false,//是否可以查看生涯测评报告
                careerTest:true,//测评

                career_test:false,  //生涯测评
                career_adaptability_test:false, //生涯适应力测评
                learning_test:false,  // 学习力测评
                learning_state_test:false,//学习状态诊断
                career_num:{}, //生涯测评的题数
                learning_capacity:{}, // 学习力的题数

            }
        },
        mounted(){
            let _this = this;                 
            this.getVersion() ;  
            this.$ajax.post(this.G_uri + '/powerTech/check', {
                  route:'/selfAssessment/main'
                },{
                    headers: {
                        token: window.sessionStorage.getItem("ymtxToken")
                    }
                }).then(res=>{
                    console.log(res,'返回判断有没有当前地址')
                    if(res.data.code == 2000){

                    }else{
                        this.$router.push('/NotFind')
                    }
                })  
        },
        methods:{
            // 获取测评题时间和题目数量
            getQuestNum(){
                this.learning_capacity = {
                    question_num:'共0道',
                    question_time:'共约0分钟'
                }
                this.career_num = {
                    question_num:'共0道',
                    question_time:'共约0分钟'
                }
                var token = window.sessionStorage.getItem('ymtxToken');
                this.$ajax.post(this.G_uri+'/career/getEvaluationTimeAndNumberQuestion',{},{
                    headers:{
                            token: token
                    }
                })
                .then((res) => {
                    // console.log(res,'题目数量');
                    if(res.data.code===2000){
                        this.learning_capacity = res.data.data.learning_capacity;
                        if(this.careerVersion==1){
                            this.career_num = res.data.data.career_v1
                        }else{
                            this.career_num = res.data.data.career_v2
                        }
                    }
                    
                })
            },
            //获取版本1老 2新
            getVersion(){
                var token = window.sessionStorage.getItem('ymtxToken');
                this.$ajax.post(this.G_uri+'/usercenter/getAgentCareerVersion',{},{
                     headers:{
                            token: token
                        }
                })
                .then((res) => {
                    this.careerVersion = res.data.data.careerVersion;
                    this.getQuestNum();
                })
            },
            //警告提示
            warning(text){
                this.$notify({
                    title: '提示',
                    message: text,
                    type: 'warning'
                });
            },
            //跳转页面
            jump(path,index){
                // console.log(path,'跳转路径')
               
                if(path=='/shengaycepingReport'){
                    if(this.careerBool){
                        window.open(this.careerLinks, '_blank');
                    }
                    return ;
                }
                if(index==0){                   
                    if(this.careerTest){
                        var link = '/shengyaceping'
                        if(this.careerVersion == 1){
                            this.goTest(link);
                        }else{
                            // console.log(path)
                           this.goTest(path);
                        }
                      
                    }
                }else{
                   this.$router.push(path)                    
                }
            },
            //跳转页面
            jumps(path){     
                this.$router.push(path)                                   
            },

            // 生涯适应力测评记录
            getReportList() {
                var _this = this;
                var token = window.sessionStorage.getItem('ymtxToken');
                this.$ajax
                    .post(this.G_uri + '/assessment/getReportList', {
                    },{
                        headers:{
                            token: token
                        }
                    })
                    // 监听数据返回
                    .then(function(res) {
                        let data = res.data.data;
                        _this.adaptabilityList = data;
                    })
                    .catch(function(error) {
                        console.log(error)
                    })
            },
            goReport(id) {
                let {href} = this.$router.resolve({
                    path: '/selfAssessment/adaptability/testreport',
                    name: '生涯适应力测评报告',
                    query: {
                        id: id,
                    }
                })
                window.open(href, '_blank');
            },

            //查看生涯测评报告
            showCareerReport(){
                this.$ajax.post(this.G_uri+this.ports.fiveQuestion.careerReport,{
                },{
                    headers:{
                        token:window.sessionStorage.getItem('ymtxToken')
                    }
                }).then(res=>{
                    if(res.data.code==2000){
                        let data=res.data.data;
                            if(data.see==1){
                                this.careerLinks=data.link;
                                this.careerBool=true;
                            }
                            if(data.link){
                                this.careerTest=false;
                            }
                    }else{
                        this.$message({
                                message: res.data.msg,
                                type: 'error'
                            });

                    }
                })
            },
            // 是否展示学习力
            getLearnCapacityStatus() {
                var _this = this;
                var token = window.sessionStorage.getItem('ymtxToken');
                let domain = this.$OEMdomain;
                this.$ajax
                    .post(this.G_uri + '/agent/getLearnCapacityStatus', {
                        webSite: domain
                    },{
                        headers:{
                            token: token
                        }
                    })
                    // 监听数据返回
                    .then((res)=> {
                        if(res.data.code == 2000) {
                            // 1是开通  2未开通
                            let status = res.data.data.status;
                            if(status==1) {
                                this.isShowLearnCapacity = true;
                            }else {
                                this.isShowLearnCapacity = false;
                            }
                        }else if(res.data.code == 1016) {
                            this.url();
                        }
                    })
                    .catch(function(error) {
                        console.log(error)
                    })
            },
            // 学习力接口one
            getModule(){
                var _this = this;
                this.$ajax.post( this.G_lcapi+'/v1_c/test/getUserModule',{
                },{
                    headers:{
                        token:window.localStorage.getItem('ymtxLocalToken')
                    }
                }).then(res=>{
                    // console.log(res)  
                    if(res.data.code === 2000){
                        this.getCreate(res.data.data);
                    }                   
                })
            },
            getCreate(module){
                let _this = this;
                this.$ajax.post( this.G_lcapi+'/v1_c/test/create',{
                    module:module    
                },{
                    headers:{
                        token:window.sessionStorage.getItem('ymtxToken')
                    }
                })
                    .then(function(res) {
                        if(res.data.code == 2000) {
                            // code: 1.第一次测试2.继续测试3.测试完成4.绑卡
                            //  _this.getUser(); 
                            var code = res.data.data.code
                            var testId=res.data.data.testId
                            window.sessionStorage.setItem('testId',testId)
                            if(code == 3) {
                                let {href}=_this.$router.resolve({
                                    path: '/cepingwancheng'
                                })
                                window.open(href, '_blank');
                                return;
                            }else if(code == 4){
                                this.pathUrl = '/learningAbility';
                                this.cardType = 'B';
                                this.isShowjihuoka = true;
                                this.cardTitle = '学习力卡';
                                return;

                            }else{
                                let link = null;
                                var userAgent = navigator.userAgent; 
                                //取得浏览器的userAgent字符串
                                // alert(userAgent,'浏览器类型')
                                if(userAgent.indexOf("Chrome") >= 0){
                                    if(this.$OEMdomain==='http://39.98.37.134'){
                                       link = 'http://39.98.37.134:9005';                                   
                                       window.open(link + '/learningcapacitytest/#/learningAbility','_blank')
                                    }else{
                                        window.open('/learningcapacitytest/#/learningAbility','_blank')
                                    }
                                }else{
                                   this.$confirm('请使用谷歌浏览器进行测评', '提示', {
                                    confirmButtonText: '确定',
                                    cancelButtonText: '取消',
                                        type: 'warning'
                                    })
                                }                               
                            }
                        }else if(res.data.code == 1016) {
                            this.url();
                        }
                    }.bind(this))
                    .catch(function(error) {
                        console.log(error)
                    })


            },
            //获取用户信息
            getUser(){
                this.$ajax.post('/papi/login/getUserInfo',{
                },{
                    headers:{
                        token:window.localStorage.getItem('ymtxLocalToken')
                    }
                }).then(res=>{
                    // console.log(res);
                    let data = res.data;
                    if(data.code === 2000){
                        window.sessionStorage.setItem('token',window.localStorage.getItem('ymtxLocalToken'))
                        window.sessionStorage.setItem('UserID',data.data.senior_user_id);
                        window.sessionStorage.setItem('schoolID',data.data.agent_high_school_id);
                        window.sessionStorage.setItem('userID',data.data.senior_user_id);
                        window.sessionStorage.setItem('SchoolID',data.data.agent_high_school_id);
                        
                    }
                })
            } ,
            
            goCreateLearningTest() {
                //  window.open('http://localhost:8080/#/learningAbility','_blank')

                this.getModule();
            },
            goTest(path) {
                console.log(path)
                let token = window.sessionStorage.getItem('ymtxToken');
                let _this = this;
                let domain = this.$OEMdomain;
                let url = path;
               if(path == '/shengyaceping'){
                    this.$ajax.post(this.G_uri + '/chooseSubject/startTest',{
                        testType: 1,
                },{
                    headers:{
                        token: token
                    }
                })
                .then(function(res) {
                    console.log(res)
                    if(res.data.code == 2000) {
                        // code: 1.第一次测试2.继续测试3.测试完成4.绑卡
                        if(res.data.data.code == 4) {
                            _this.pathUrl = path;
                            _this.cardType = 1;
                            _this.cardTitle = '生涯卡';
                            // 如果是知否教育用绑卡和在线激活，其他用绑卡
                            if(domain=='zf.xuematech.com') {
                                _this.isShowjihuoka = true;
                                _this.codeUrl = 'http://' + domain + '/papi/' + res.data.data.qrCode;
                            }else {
                                _this.isShowjihuoka = true;
                            }
                            return;
                        }else {
                            let {href}=_this.$router.resolve({
                                path: path
                            })
                            
                            window.open(href, '_blank');
                        }
                    }else if(res.data.code == 1016) {
                        _this.$router.push('/login');
                    }else if(res.data.code == 2026) {
                        _this.$router.push('/perfectInformation');
                    }
                })
                .catch(function(error) {
                    console.log(error)
                    // alert('当前服务器繁忙，请刷新')
                });
               }else if(path == '/careerevalution'){
                  
                   this.$ajax.post(this.G_capi + '/test/create',{
                    
                },{
                    headers:{
                        token: token
                    }
                })
                .then(function(res) {
                    if(res.data.code == 2000) {
                        // code: 1.第一次测试2.继续测试3.测试完成4.绑卡
                        if(res.data.data.code == 4) {
                            _this.pathUrl = path;
                            _this.cardType = 1;
                            _this.cardTitle = '生涯卡';
                            // 如果是知否教育用绑卡和在线激活，其他用绑卡
                            if(domain=='zf.xuematech.com') {
                                _this.isShowjihuoka = true;
                                _this.codeUrl = 'http://' + domain + '/papi/' + res.data.data.qrCode;
                            }else {
                                _this.isShowjihuoka = true;
                            }
                            return;
                        }else {
                            // let {href}=_this.$router.resolve({
                            //     path: path
                            // })
                            // window.open(href, '_blank');
                            let routeUrl = _this.$router.resolve({
                                path: path
                                // query: {id:96}
                            });
                            window.open(routeUrl.href, '_blank');




                        }
                    }else if(res.data.code == 1016) {
                        _this.$router.push('/login');
                    }else if(res.data.code == 2026) {
                        _this.$router.push('/perfectInformation');
                    }
                })
                .catch(function(error) {
                    console.log(error)
                    // alert('当前服务器繁忙，请刷新')
                });
               }
            },
        
            //退出确认
            exitConfirm(){
                if(this.who==''&&this.he==''&&this.ICanReach==''&&this.IGoTo==''&&this.IDoIt==''&&this.date==''&&this.wuwengId==''){
                    this.addtanchuang=false;
                    return;
                }
                this.$confirm('当前内容还未保存，是否退出?', '提示', {
                    confirmButtonText: '退出',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.addtanchuang=false
                    this.clear();
                    this.$message({
                        type: 'info',
                        message: '已退出'
                    });
                }).catch((error) => {

                })
            },

        },
        watch: {
            isShowMark() {
                if(this.isShowMark) {
                    this.getReportList();
                }               
            }             
        },
        computed:{
            getList(){
                const _this = this
                const itemObj = _this.$store.state.routeConfig.find(item=>{
                    return item.link === '/selfAssessment/main'
                })||{}
                //  console.log(itemObj)

                const obj ={
                    career_test:false,
                    learning_test:false,
                    career_adaptability_test:false,
                    learning_state_test:false
                }
                for(let item of (itemObj.list||[])){
                    if(item.name=='生涯测评'){
                        obj.career_test = true;
                        console.log('含有生涯测评');
                    }
                    if(item.name=='学习力测评'){
                        obj.learning_test = true; 
                    }
                    if(item.name=='生涯适应力测评'){
                        obj.career_adaptability_test = true;
                    }
                    if(item.name=='学习状态诊断测评'){
                        obj.learning_state_test = true;
                    }  
            }
             
             return obj     
            },
        },
        created(){
            if(this.$OEMdomain=='zf.xuematech.com') {
                this.isZhifou = true;
            }else {
                this.isZhifou = false;   
            }
            // this.getLearnCapacityStatus();
            // this.showCareerReport();
        }
    }
</script>
<style scoped lang="less">
   .come_box{
       display: block !important;
   }
   .come_icon{
       width: 72px;
    height: 72px;
    margin: 30px auto 0px !important;
    display: block;
   }
   .come_text{
       text-align: center;
       line-height: 38px !important;
       color: #bfbfbf !important;
       font-size:24px;
   }
    .item_scoll{
        position: relative;
        width: 1024px;
        height: 45px;
    }
    .tishi {
        position: absolute;
        width: 100%;
        height: 50px;
        // padding-left: 40px;
        line-height: 50px;
        font-size: 16px;
        left: 0;
        top: 0px;
        // z-index: 100;
        color: #333333;
        font-weight: 500;
        background-color: rgba(255,255,255,.5);
        .box {
            // width: 1200px;
            margin: 0 auto;
            background: url(/imgs/selfAssessment/icon_deng3.png) no-repeat left center;
            position: relative;
            height: 50px;
            margin-left: 10px;
        }
        span {
            float: right;
            width: 42px;
            height: 50px;
            background: url(/imgs/home/icon_close3.png) no-repeat center center;
            cursor: pointer;
        }
        transition: .5s;
    }
    .quest_num{
        color: #2c8ffc !important;
        margin-top: 5px;
        font-size: 14px;
         img{
            margin-right: 3px !important;
        }
        > span{
            margin-right: 18px;
            
        }
    }
    .noneContent{
        margin: 0 auto;
        padding: 30px 0;
        width: 126px;
        height:120px;
        background: url("/imgs/careerManagement/careerAnchor/noneContent.png") no-repeat center;
    }
    .add {
        width: 62px;
        height: 26px;
        border-radius: 3px;
        text-align: center;
        line-height: 26px;
        background: #3A90F3;
        color: #fff;
        cursor: pointer;
        margin-left: 40px;
        margin-top: 20px;
        margin-bottom: 10px;
        position: absolute;
        right: 20px;
        top: 30px;
    }
    .addTests{
        &>img{
            display: block;
            width: 100%;
            margin-bottom: 22px;
        }
        background-color: #fff;
        position: fixed;
        left: 50%;
        top: 50%;
        margin-left: -400px;
        margin-top: -185px;
        width: 800px;
        height: 370px;
        z-index: 20;
        .head{
            position: absolute;
            top: 0;
            left: 0;
            line-height: 60px;
            text-align: center;
            background: none;
            width: 100%;
            font-size: 20px;
            color:#fff;
            letter-spacing: 2px;
        }
        table{
            tr:first-child{
                background: #F3F4F8;
            }
            td{
                border:1px solid #DDDFDE;
                text-align: center;
                height: 50px;
                textarea{
                    display: block;
                    box-sizing: border-box;
                    padding: 10px;
                    width: 100%;
                    height: 100%;
                    background: none;
                    border:none
                }
            }
            tr:last-child{
                td{
                    height: 150px;
                }
            }

        }
        .save{
            width: 110px;
            height: 42px;
            text-align: center;
            line-height: 42px;
            border-radius: 5px;
            font-size: 17px;
            color:#fff;
            margin: 24px auto 0;
            background: #3B91F4;
            cursor: pointer;
        }
        .close {
            width: 36px;
            height: 36px;
            position: absolute;
            right: 13px;
            top: 13px;
            cursor: pointer;
        }
    }
    .tables{
        padding:0 15px;
    }
    .tables2{
        padding:25px 0  40px;
        table{
            border-collapse: collapse;
            border:1px solid #EAEAEA;
            tr:nth-of-type(1){
                background: #F3F4F8;
            }
            td{
                line-height:40px;
                height: 40px;
                border:1px solid #EAEAEA;
                text-align: center;
                .icon{
                    display: inline-block;
                    width: 34px;
                    height: 20px;
                    border-radius: 3px;
                    cursor: pointer;
                    position: relative;
                    top:5px;
                    background-position: center;
                    background-repeat: no-repeat;
                    background-image:url("/imgs/schoolWork/icon_bianjihui.png") ;
                    &:hover{
                        background-image:url("/imgs/schoolWork/icon_bianjibai.png");
                        background-color: #3087E6;
                    }
                }
                .icon2{
                    background-image:url("/imgs/schoolWork/icon_lajitonghui.png");
                    &:hover{
                        background-image:url("/imgs/schoolWork/icon_lajitongbai.png");
                        background-color: #FB4945;
                    }
                }
                .finshed{
                    width: 60px;
                    height: 20px;
                    display: inline-block;
                    background: #F3F4F8;
                    color:#666666;
                    position: relative;
                    top:0px;
                    line-height: 20px;
                    cursor: pointer;
                    font-size: 12px;
                }
                span{
                    color:#3D90F6;
                    cursor: pointer;
                }
            }
        }
    }

    .explore{
        *{
            box-sizing: border-box;
            letter-spacing: 1.5px;
        }
        // width: 100%;
        padding-left: 20px;
        .parts {
            background: #fff;
            padding: 0 16px;
            margin-bottom: 20px;
            .top {
                img {
                    margin-right: 10px;
                }
                .title {
                    font-size: 17px;
                    color: #348DF1;
                    font-weight: bolder;
                    padding-top: 24px;
                    letter-spacing: 2px;
                }

                span {
                    float: right;
                    display: block;
                    width: 62px;
                    height: 26px;
                    border-radius: 3px;
                    text-align: center;
                    line-height: 26px;
                    background: #3A90F3;
                    position: relative;
                    top: -20px;
                    color: #fff;
                    cursor: pointer;
                }
            }
            & > p {
                padding-left: 40px;
                line-height: 60px;
                color: #666;
            }
            .list {
                padding-bottom: 25px;
                width: 100%;
                display: flex;
                justify-content: space-between;
                & > li {
                    width: 298px;
                    min-height: 256px;
                    background-repeat: no-repeat;
                    background-color: #FAFBFC;
                    p {
                        line-height: 56px;
                        text-align: center;
                        font-size: 16px;
                        color: #fff;
                    }
                    .zhiye {
                        padding: 10px 25px 10px;

                        li {
                            width: 100%;
                            line-height: 20px;
                            span {
                                display: inline-block;
                                width: 4px;
                                height: 4px;
                                border-radius: 50%;
                                background: #3B91F4;
                                margin-right: 10px;
                                position: relative;
                                top: 0;
                                color: #666666;
                            }
                        }
                    }
                }
                & > li:nth-of-type(1) {
                    background-image: url("/imgs/careerManagement/careerAnchor/icon_tuijian1.png");
                }
                & > li:nth-of-type(2) {
                    background-image: url("/imgs/careerManagement/careerAnchor/icon_tuijian2.png");
                }
                & > li:nth-of-type(3) {
                    background-image: url("/imgs/careerManagement/careerAnchor/icon_tuijian3.png");
                }
            }
            .card {
                display: flex;
                justify-content: space-between;
                padding: 0 0 25px 30px;

                li {
                    width: 410px;
                    height: 247px;
                    .cardZheng {
                        width: 230px;
                        float: right;
                        padding-top: 50px;
                        p {
                            line-height: 36px;
                            color: #333333;
                        }
                    }
                    .cardFan {
                        padding-top: 140px;
                        text-align: center;
                        font-size: 16px;
                    }
                }
                li:nth-of-type(2) {
                    background: url("/imgs/careerManagement/careerAnchor/icon_fanmian.png");
                }
            }
            h3 {
                font-size: 15px;
                color: #333;
                font-weight: bolder;
                line-height: 36px;
                text-indent: 25px;
                margin-bottom: 15px;
            }
            .yixiang {
                width: 100%;
                padding-left: 25px;
                max-height: 325px;
                margin-bottom: 20px;
                .left {
                    float: left;
                    width: 154px;
                    height: 100%;
                    border-right: 1px solid #EAEAEA;
                    li {
                        width: 100%;
                        height:65px;
                        overflow: hidden;
                        line-height: 65px;
                        .img {
                            width: 30px;
                            height: 28px;
                            display: inline-block;
                            position: relative;
                            top:8px;
                        }
                    }
                    li:nth-of-type(1) .img{
                        background: url("/imgs/careerManagement/careerAnchor/icon_01.png");
                    }
                    li:nth-of-type(2) .img{
                        background: url("/imgs/careerManagement/careerAnchor/icon_02.png");
                    }
                    li:nth-of-type(3) .img{
                        background: url("/imgs/careerManagement/careerAnchor/icon_03.png");
                    }
                    li:nth-of-type(4) .img{
                        background: url("/imgs/careerManagement/careerAnchor/icon_04.png");
                    }
                    li:nth-of-type(5) .img{
                        background: url("/imgs/careerManagement/careerAnchor/icon_05.png");
                    }
                }
                .right {
                    width: 684px;
                    height: 100%;
                    float: left;
                    li {
                        width: 100%;
                        height: 65px;
                        padding-top: 20px;
                        .hui {
                            position: relative;
                            height: 30px;
                            background: #EEEEEE;
                            .lan {
                                position: absolute;
                                left: 0;
                                top: 0;
                                width: 0;
                                height: 100%;
                                background: #3C8DE8;
                                transition: 1s linear;
                            }
                        }
                    }
                }
                .fen {
                    width: 60px;
                    height: 100%;
                    float: left;
                    li {
                        height: 20%;
                        line-height: 65px;
                        text-indent: 10px;
                    }
                }

            }


        }
        .electiveBox{
            background: #fff;
            // padding:0px 0px 10px 0px;
            border-radius: 5px;
            display: flex;
            justify-content: space-between;
            align-content: space-between;
            flex-wrap: wrap;
            li{
                position: relative;
                width: 485px;
                height: 203px;
                border-radius: 5px;
                border:1px solid #EBEBEB;
                padding: 15px 0px;
                display: flex;
                .left{
                    // width: 90px;
                    padding-left: 15px;
                    width: 171px;
                    text-align: center;
                }
                .right{
                    width: 360px;
                    float: right;
                    padding-right: 33px;
                    padding-left: 33px;
                    .title{
                        font-weight: bolder;
                        font-size: 18px;
                        height: 24px;
                        display: flex;
                        align-items: center;
                        color:#333;
                        padding: 0;
                        margin-bottom: 10px;
                        img {
                            margin-left: 5px;
                        }
                    }
                    p{
                        line-height: 20px;
                        color:#333;
                        font-size: 14px;
                    }
                    .button{
                        background: #3D90F6;
                        border-radius: 20px;
                        text-align: center;
                        //letter-spacing: 3px;
                        line-height: 30px;
                        color:#fff;
                        font-size: 14px;
                        width: 80px;
                        position: absolute;
                        // right: 28px;
                        bottom: 20px;
                        cursor: pointer;
                    }
                }
            }
        }
        .myReports{
            width: 970px;
            background: #fff;
            margin-top: 20px;
            padding: 0 16px;
            img{
                margin-right: 10px;
            }
            .title{
                font-size: 17px;
                color: #348DF1;
                font-weight: bolder;
                padding-top: 24px;
                letter-spacing: 2px;
                margin-bottom: 24px;
            }
            p{
                line-height: 62px;
                color:#333333;
            }
            .list{
                padding-top: 20px;
                flex-wrap: wrap;
                overflow: hidden;
                li{
                    float: left;
                    width: 50%;
                    height: 60px;
                    margin-bottom: 20px;
                    .img{
                        float: left;
                        width: 90px;
                        height: 60px;
                        margin-right: 10px;
                    }
                    .right{
                        float: left;
                        width: 332px;
                        p{
                            font-size: 14px;
                            line-height: 18px;
                            font-weight: bolder;
                            color:#000;
                            &:hover{
                                color:#3492F9;
                            }
                            cursor: pointer;
                        }
                        div{
                            span{
                                font-size: 12px;
                                color:#676767;
                                position: relative;
                                top:2px;
                                left:-2px;
                            }
                        }
                    }
                }
            }
        }
        .mark {
            position: fixed;
            left: 0;
            top: 0;
            bottom: 0;
            right: 0;
            z-index: 10;
            background: rgba(0,0,0,.5);
            .tips {
                width: 652px;
                height: 408px;
                padding-top: 96px;
                position: absolute;
                left: 50%;
                top: 50%;
                margin-top: -204px;
                margin-left: -326px;
                background: url(/imgs/selfAssessment/bg_chakancepingjilu.png) no-repeat;
                ul {
                    padding: 0px 50px 0px 40px;
                    height: 276px;
                    overflow-y: auto;
                    li {
                        border-bottom: 1px dashed #eaeaea;
                        height: 46px;
                        line-height: 46px;
                        font-size: 14px;
                        color: #2c8ffc;
                        // span {
                        //     cursor: pointer;
                        // }
                        .btn {
                            float: right;
                            width: 76px;
                            height: 30px;
                            line-height: 30px;
                            border-radius: 3px;
                            background-color: #2c8ffc;
                            color: #fff;
                            text-align: center;
                            margin-top: 8px;
                            cursor: pointer;
                        }
                    }
                }
                .close {
                    width: 36px;
                    height: 36px;
                    position: absolute;
                    right: 13px;
                    top: 13px;
                    cursor: pointer;
                }
            }
        }
    }
</style>
<style>
    #selfexplore .el-date-editor{
        width: 160px;
    }
</style>
<style scoped lang="less">
    .schoolWork{
        *{
            box-sizing: border-box;
            letter-spacing: 1px;
        }
        border-radius: 5px;
        width: 100%;
        .schoolWorkBox{
            position: relative;
            // width: 970px;
            background: #fff;
            // padding: 0 18px;

            img{
                margin-right: 10px;
            }
            .img{
                display: inline-block;
                width: 8px;
                height: 8px;
                background: #3D90F6;
            }
            .title{
                font-size: 17px;
                color: #348DF1;
                font-weight: bolder;
                padding-top: 18px;
                padding-bottom: 18px;
            }
            .small_title {
                font-size: 15px;
                color: #333;
                line-height: 40px;
                font-weight: bold;
            }
            p{
                line-height: 62px;
                color:#333333;
            }
            .list{
                display: flex;
                justify-content: space-between;
                height: 100px;
                width: 100%;
                li{
                    width: 296px;
                    height: 80px;
                    line-height: 80px;
                    border:1px solid #e5e5e5;
                    border-radius: 5px;
                    display: flex;
                    align-items: center;
                    padding: 0 15px;

                    span{
                        font-size: 16px;
                        color:#3D90F6;
                        font-weight: bold;
                        margin-left: 20px;
                        flex: 1;
                    }
                    img{
                        cursor: pointer;
                        margin-right: 0px;
                        // position: relative;
                        // top:-2px;
                        // left:10px;
                    }
                }
            }
        }
    }
    
    .flex_div{
        display: flex;
        flex-wrap: wrap;
        padding: 20px 16px;
        background: #fff;
        padding-top: 0px;
        justify-content: space-between;
        // margin-top: 20px;
        > div{
            // flex: 1;
            width: 485px !important; 
            height: 203px;
            margin: 20px 0px 0px;
        }
    }
    .schoolWork > div > img{
        width: 100%;
    }
    /deep/.explore .electiveBox li .right .button.mask{
        right: 117px !important;
        border: 1px solid #2c8ffc;
        background: none !important;;
    }
    /deep/.explore .electiveBox li .right .button.mask{
        right: 117px !important;
        border: 1px solid #2c8ffc;
        background: none !important;
    }
    .title_border{
        height: auto !important;
        width: auto !important;
        line-height: 50px;
        background: #fff;
        margin-top: 20px;
        padding: 0 16px;
        > div{
            border-bottom: 1px solid #D8D8D8;
            position: relative;
            color: #333;
            font-size: 16px;
            > span{
                position:absolute;
                bottom: 0;
                left: 0;
                width: 35px;
                height: 3px;
                background: #2c8ffc;
            }
        }
    }
</style>

